import React, { FunctionComponent, ReactElement } from 'react';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { forNamespace } from 'app/common/lib/util/i18n';
import { Dialog } from 'app/src/components/Wizard';
import styles from './EmailMigrationDialog.less';

interface EmailMigrationDialogProps {
  email: string;
  closeDialog: () => void;
  changeEmailButton?: ReactElement;
  image?: HTMLElement;
  mobileImage?: HTMLElement;
}

const format = forNamespace(['aa migration wizard', 'email migration'], {
  shouldEscapeStrings: false,
});

export const EmailMigrationDialog: FunctionComponent<EmailMigrationDialogProps> = ({
  email,
  closeDialog,
  changeEmailButton,
  image,
  mobileImage,
}) => (
  <Dialog
    closeDialog={closeDialog}
    title={format('title')}
    image={image}
    mobileImage={mobileImage}
  >
    <p className={styles.mainMessage}>
      {format('main-message', { email: <strong key="email">{email}</strong> })}
    </p>
    <p>{format('secondary-message')}</p>

    <div className={styles.buttons}>
      <PrimaryButton onClick={closeDialog}>
        {format('button-text')}
      </PrimaryButton>

      {!!changeEmailButton && changeEmailButton}
    </div>
  </Dialog>
);
